// removed by extract-text-webpack-plugin
module.exports = {"container":"_1nKIxdRwgn1TigcSXoCJ_V","section":"_2kwjFyx3AuNG0l0jwRTwMh","list":"_1shR_ujIJN0U8w8deGbcx6","item":"_2gwh7ewaO8RcPN1MlpbHEZ","smallButton":"_3wr6VLlScxxpPrDEe7udCo","addButton":"_1L64HZBxRkMgSckPh6DYwh"};


//////////////////
// WEBPACK FOOTER
// ./src/AddPractice/Info/ManualSync.css
// module id = 595
// module chunks = 0